import { render, staticRenderFns } from "./privateMessage1.vue?vue&type=template&id=ef0fc844&scoped=true"
import script from "./privateMessage1.vue?vue&type=script&lang=js"
export * from "./privateMessage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0fc844",
  null
  
)

export default component.exports